import React, { useEffect, useState } from 'react';
import { Snackbar, AlertColor } from '@mui/material';

interface AlertProps {
    message: string;
    title: string;
    type: AlertColor;
}
// "success" | "info" | "warning" | "error"
const Alert: React.FC<AlertProps> = ({title, message, type }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
    const timer = setTimeout(() => {
      setOpen(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [message]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
        <div>
        {type === "success" &&
            <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded-md">
                <div className="flex">
                    <div className="flex-shrink-0">
                    <i className="bi bi-check-circle-fill h-5 w-5 text-green-400"></i>
                    </div>
                    <div className="ml-3">
                    <p className="text-sm font-medium text-green-800">{title}</p>
                    <p className="text-sm text-green-700 mt-1">
                        {message}
                    </p>
                    </div>
                </div>
            </div>
        }
        {type === "info" && 
            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-md">
                <div className="flex">
                    <div className="flex-shrink-0">
                   
                    <i className="bi bi-info-circle-fill h-5 w-5 text-blue-400"></i>
                    </div>
                    <div className="ml-3">
                    <p className="text-sm font-medium text-blue-800">{title}</p>
                    <p className="text-sm text-blue-700 mt-1">
                        {message}
                    </p>
                    </div>
                </div>
            </div>
        }
        {type === "warning" && 
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-md">
                <div className="flex">
                    <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.68-1.36 3.445 0l6.518 11.604c.746 1.327-.213 2.997-1.722 2.997H3.461c-1.509 0-2.468-1.67-1.722-2.997L8.257 3.1zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-.25-4.75a.75.75 0 00-1.5 0v2.5a.75.75 0 001.5 0v-2.5z" clipRule="evenodd" />
                    </svg>
                    </div>
                    <div className="ml-3">
                    <p className="text-sm font-medium text-yellow-800">{title}</p>
                    <p className="text-sm text-yellow-700 mt-1">
                        {message}
                    </p>
                    </div>
                </div>
            </div>

        }
        {type === "error" &&
            <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-md">
                <div className="flex">
                    <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.68-1.36 3.445 0l6.518 11.604c.746 1.327-.213 2.997-1.722 2.997H3.461c-1.509 0-2.468-1.67-1.722-2.997L8.257 3.1zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-.25-4.75a.75.75 0 00-1.5 0v2.5a.75.75 0 001.5 0v-2.5z" clipRule="evenodd" />
                    </svg>
                    </div>
                    <div className="ml-3">
                    <p className="text-sm font-medium text-red-800">{title}</p>
                    <p className="mt-1 text-sm text-red-700 list-disc pl-5 space-y-1">
                        {message}
                    </p>
                    </div>
                </div>
            </div>
        } 
        </div>
    </Snackbar>
  );
};

export default Alert;